/**
 * ONE definition of "A to Z" for the whole portal.
 *
 * Case-insensitive, accent-insensitive and numeric-aware, in the user's
 * current language (EN/FR/ES) via Intl.Collator. Names that start with a
 * symbol or emoji sort AFTER the letters instead of jumping to the top.
 *
 * Use `sortByName` for organizations, locations/restaurants/stores,
 * employees and any picker list; `sortByTagId` for cards, which are read
 * by the id printed on them (#3BRASPC002 before #3BRASPC010).
 */
import i18n from './i18n';

const collatorFor = (lang) =>
    new Intl.Collator(lang || i18n?.language || 'en', { sensitivity: 'base', numeric: true });

const leadsWithWordChar = (s) => (/^[\p{L}\p{N}]/u.test(s) ? 0 : 1);

export function sortByName(list, getName = (x) => x?.name, lang) {
    if (!Array.isArray(list)) return [];
    const collator = collatorFor(lang);
    return [...list].sort((a, b) => {
        const an = String(getName(a) ?? '').trim();
        const bn = String(getName(b) ?? '').trim();
        return leadsWithWordChar(an) - leadsWithWordChar(bn) || collator.compare(an, bn);
    });
}

export const sortByTagId = (list, lang) =>
    sortByName(list, (c) => c?.card_id || c?.tag_id || c?.name, lang);

export default sortByName;
